export const walletRoutes: string[] = [
  'wallet',
  'portefeuille',
  'portemonaie',
  'monedero',
  'brieftasche',
  'portafoglio'
];

export const brandsRoutes: string[] = ['brands', 'marques', 'marcas', 'marken', 'marchi'];

export const secondHandLuxuryRoutes: string[] = [
  'occasion-luxe',
  'sale-second-hand-luxury',
  'sale-zweite-hand-luxus',
  'rebajas-segunda-mano-lujo',
  'saldi-seconda-mano-lusso'
];

export const commonRoutes: string[] = ['comments', 'api', 'tools', 'webservice', 'admin', 'ns'];

export const aboutRoutes: string[] = ['a-propos', 'about', 'uber-uns', 'a-proposito', 'quienes-somos'];

export const sponsorshipRoutes: string[] = [
  'parrainage',
  'refer-a-friend',
  'freundschaftswerbung',
  'apadrinamiento',
  'invitare-tutti-gli-amici'
];

export const conceptPreownedFashionRoutes: string[] = [
  'concept-depot-vente-luxe',
  'concept-preowned-fashion',
  'luxusmode-zweiterhand-concept',
  'concepto-moda-segunda-mano',
  'concept-moda-seconda-mano'
];

export const privacyPolicyRoutes: string[] = [
  'privacy-policy',
  'politique-de-confidentialite',
  'datenschutzrichtlinie',
  'politica-sulla-privacy',
  'politica-de-confidencialidad'
];

export const dropThePriceRoutes: string[] = [
  'baisser-le-prix',
  'drop-the-price',
  'den-preis-senken',
  'reducir-el-precio',
  'abbassare-il-prezzo'
];

export const removeFromSaleRoutes: string[] = [
  'retirer-de-la-vente',
  'remove-from-sale',
  'artikel-aus-dem-verkauf-nehmen',
  'rimuovere-dalla-vendita',
  'retirar-de-la-venta'
];

export const applicationsRoutes: string[] = ['applications', 'applicazioni', 'aplicaciones', 'anwendung'];

export const sellSecondHandClothesRoutes: string[] = [];

export const cancelSaleRoutes: string[] = [
  'annulation-de-la-vente',
  'cancel-my-sale',
  'brechen-sie-meinen-verkauf-ab',
  'annulla-la-mia-vendita',
  'cancelar-mi-venta'
];

export const affiliateRoutes: string[] = [
  'affiliation.shtml',
  'affiliate-program.shtml',
  'affiliate-programm.shtml',
  'programa-de-afiliacion.shtml',
  'programma-di-affiliazione.shtml'
];

export const exceptionRoutes: string[] = [
  ...walletRoutes,
  ...brandsRoutes,
  ...secondHandLuxuryRoutes,
  ...commonRoutes,
  ...aboutRoutes,
  ...sponsorshipRoutes,
  ...conceptPreownedFashionRoutes,
  ...privacyPolicyRoutes,
  ...dropThePriceRoutes,
  ...removeFromSaleRoutes,
  ...applicationsRoutes,
  ...sellSecondHandClothesRoutes,
  ...cancelSaleRoutes
];

/**
 * To match externalLinkLoggedMatcher
 */
export const loggedExceptionPath: string[] = [];

/**
 * To check full url
 */
export const loggedExceptionUrl: string[] = [];
